<div class="vd_body" *ngIf="!isLoading" >
    <!-- Header Start -->
    
    <!-- Header Ends --> 
    <div class="content">
      <div class="container"> 
        
        <!-- Middle Content Start -->
        
        <div class="vd_content-wrapper" style="min-height: 8px;">
          <div class="vd_container" style="min-height: 8px;">
            <div class="vd_content clearfix">
              <div class="vd_content-section clearfix">
                <div class="vd_register-page">
                  <div class="heading clearfix">
                    <div class="logo">
                      <!-- <h2><img src="img/logo.png" alt="logo"></h2> -->
                    </div>
                  </div>
                  <div class="panel widget">
                    <div class="panel-body">
                      <div class="login-icon"> <i class="fa fa-sign-out"></i> </div>
                      <h1 class="font-semibold text-center" style="font-size:52px">You Have Been Logged Out</h1>
                      <form class="form-horizontal" action="#" role="form">
                        <div class="form-group">
                          <div class="col-md-12">
                            <h4 class="text-center mgbt-xs-20">Thank you for using the Platform</h4>
                            <p class="text-center"> Please <a href="/authentication/login">click here</a> to login back</p>
    
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  <!-- Panel Widget -->
                </div>
                <!-- vd_login-page --> 
                
              </div>
              <!-- .vd_content-section --> 
              
            </div>
            <!-- .vd_content --> 
          </div>
          <!-- .vd_container --> 
        </div>
        <!-- .vd_content-wrapper --> 
        
        <!-- Middle Content End --> 
        
      </div>
      <!-- .container --> 
    </div>
    <!-- .content -->
    
    <!-- Footer Start -->
      <footer class="footer-2" id="footer">      
        <div class="vd_bottom ">
            <div class="container">
                <div class="row">
                  <div class=" col-md-12">
                    <div class="copyright text-center">
                          Copyright ©2025. All Rights Reserved 
                    </div>
                  </div>
                </div><!-- row -->
            </div><!-- container -->
        </div>
      </footer>
    <!-- Footer END -->
    
</div>

<div class="content" *ngIf="isLoading">
  Please wait...
</div>
